import angular from "angular";

import AuthModuleRouting from "./auth.module.routing";

export default angular
    .module("vt-auth", [])
    .config(AuthModuleRouting);
